import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { CargoPlanilla } from 'src/app/Models/planilla/cargo-planilla';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-cargo',
  templateUrl: './cargo.component.html',
  styleUrls: ['./cargo.component.css']
})
export class CargoComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public search    = '';
  public page: any;
  public total     = 0;
  public items: CargoPlanilla[] = [];
  public nuevo: CargoPlanilla   = new CargoPlanilla();
  public agregando              = false;
  private _backup: {[id: number]: any} = {};

  constructor(private data: DataService, private title: Title) {}

  ngOnInit() {
    this.title.setTitle('Cargos | Sistema');
    this.GetData();
  }

  GetData() {
    this.loading.show('Cargando...');
    this.items = [];
    const req = this.search
      ? this.data.GetFromValue(this.data.api.cargos_planilla, 'nombre__icontains', this.search)
      : this.data.GetSimple(this.data.api.cargos_planilla);
    req.subscribe(
      r => { this.loading.hide(); this.items = r; this.total = r.length; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowNew()   { this.nuevo = new CargoPlanilla(); this.agregando = true; }
  CancelNew() { this.agregando = false; this.nuevo = new CargoPlanilla(); }
  formNewValid(): boolean { return !!(this.nuevo.codigo && this.nuevo.nombre); }

  SaveNew() {
    this.loading.show('Registrando...');
    this.data.Post(this.data.api.cargos_planilla, this.nuevo).subscribe(
      r => { this.loading.hide(); this.agregando = false; this.nuevo = new CargoPlanilla(); this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  StartEdit(item: CargoPlanilla)  { this._backup[item.idcargo] = { ...item }; item.editando = true; }
  CancelEdit(item: CargoPlanilla) { Object.assign(item, this._backup[item.idcargo]); item.editando = false; }

  SaveEdit(item: CargoPlanilla) {
    this.loading.show('Actualizando...');
    this.data.Put(this.data.api.cargos_planilla, `${item.idcargo}`, item).subscribe(
      r => { this.loading.hide(); item.editando = false; delete this._backup[item.idcargo]; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowDelete(item: CargoPlanilla) {
    this.info.show(`¿Deseas eliminar el cargo "${item.nombre}"?`, 1, null,
      { cancelText: 'No, Cancelar', successText: 'Sí, Eliminar', isCancel: true },
      () => this.Delete(item), () => { this.info.hide(); }, 20);
  }

  Delete(item: CargoPlanilla) {
    this.loading.show('Eliminando...');
    this.data.Delete(this.data.api.cargos_planilla, `${item.idcargo}`).subscribe(
      r => { this.loading.hide(); this.info.show(r.message, 2, null, null, () => { this.info.hide(); this.GetData(); }); },
      e => { this.loading.hide(); this.info.error(e, () => this.info.hide()); }
    );
  }
}
